module.exports = __webpack_public_path__ + "static/img/business_03.751ef6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investCenter/business_03.png
// module id = VWE/
// module chunks = 0